"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAccess = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const requestAccess = async (firstName, lastName, email, phoneNumber, companyName, companyWebsite, companyCountry, optionalMessage) => {
    const email_obj = {
        language_code: "en",
        data: {
            agent: {
                logo: "https://golfsavers.b-cdn.net/assets/images/golfb2b_email_logo.jpg",
            },
            firstName,
            lastName,
            email,
            phoneNumber,
            companyName,
            companyWebsite,
            companyCountry,
            optionalMessage,
        },
        template_id: helpers_1.GOLFB2B_REGISTRATION_NOTIFICATION,
    };
    await (0, sendEmail_1.sendEmail)(email_obj);
    return null;
};
exports.requestAccess = requestAccess;
